import { useState } from 'react';
import dayjs from 'dayjs';
import { Modal, Stack, Text, Button, Group, TextInput } from '@mantine/core';
import { useFetchSIIBook } from '@api/documents';

interface Props {
  opened: boolean;
  close: () => void;
  bookType: 'sales' | 'purchases';
}

function FetchSIIBookModal({ opened, close, bookType }: Props) {
  const currentMonth = dayjs().format('YYYY-MM');
  const [startMonth, setStartMonth] = useState(currentMonth);
  const [endMonth, setEndMonth] = useState(currentMonth);
  const { mutate: fetchBook, isLoading } = useFetchSIIBook();

  const isRangeInvalid = startMonth > endMonth;

  const handleSubmit = () => {
    fetchBook(
      { book_type: bookType, start_month: startMonth, end_month: endMonth },
      { onSuccess: close },
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={
        <Text fz={18} fw={600}>
          Buscar en el SII
        </Text>
      }
      centered
    >
      <Stack>
        <Text c="dimmed" fz="sm">
          Sincroniza el {bookType === 'sales' ? 'libro de ventas' : 'libro de compras'} directamente
          desde el SII para el rango de meses indicado. Los documentos se importarán en los
          próximos minutos.
        </Text>
        <Group grow>
          <TextInput
            type="month"
            label="Desde"
            value={startMonth}
            onChange={(e) => setStartMonth(e.currentTarget.value)}
            max={endMonth}
          />
          <TextInput
            type="month"
            label="Hasta"
            value={endMonth}
            onChange={(e) => setEndMonth(e.currentTarget.value)}
            min={startMonth}
            error={isRangeInvalid ? 'El mes inicial no puede ser mayor al final' : undefined}
          />
        </Group>
        <Group justify="flex-end" mt="xs">
          <Button variant="subtle" onClick={close} disabled={isLoading}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} loading={isLoading} disabled={isRangeInvalid}>
            Buscar en SII
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default FetchSIIBookModal;
